module.exports = __webpack_public_path__ + "static/img/name2.c33cdc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/th/name2.png
// module id = zDIW
// module chunks = 1